// --- Business Activities ---
export const ACTIVITIES = [
  {
    id: "consulting",
    label: "Consulting & Professional Services",
    sub: "Consulting, Recruitment, Business Accelerator",
    baseCost: 0,
  },
  {
    id: "tech",
    label: "Technology & IT",
    sub: "Technology, Telecommunications, Communications",
    baseCost: 500,
  },
  {
    id: "ecommerce",
    label: "E-Commerce & Retail",
    sub: "E-commerce, Retail, Apparel, Electronics",
    baseCost: 1000,
  },
  {
    id: "trading",
    label: "Trading & Import/Export",
    sub: "Shipping, Machinery, Chemicals, Manufacturing",
    baseCost: 1500,
  },
  {
    id: "food",
    label: "Food & Hospitality",
    sub: "Food & Beverage, Hospitality, Recreation",
    baseCost: 2000,
  },
  {
    id: "construction",
    label: "Construction & Real Estate",
    sub: "Construction, Engineering, Environmental",
    baseCost: 2500,
  },
];

// --- Setup Reasons ---
export const REASONS = [
  { id: "new",        label: "New company formation" },
  { id: "expansion",  label: "Expansion plan (ie. new branch or franchise)" },
  { id: "relocation", label: "Company relocation" },
  { id: "visa",       label: "Visa purposes only" },
];

// --- Office Types ---
export const OFFICES = [
  { id: "virtual",         label: "Virtual Office",    sub: "Work from anywhere lightest cost",    price: 2000  },
  { id: "physical",        label: "Physical Office",   sub: "Dedicated private office space",        price: 5000  },
  { id: "shopfront",       label: "Shop Front",        sub: "Retail or customer-facing space",       price: 8000  },
  { id: "business_centre", label: "Business Centre",   sub: "Shared workspace and meeting rooms",    price: 3500  },
  { id: "warehouse",       label: "Warehouse",         sub: "Industrial or storage space",           price: 10000 },
];

// --- Jurisdictions ---
export const JURISDICTIONS = [
  { id: "freezone", label: "Free Zone", sub: "International clients, e-commerce, consulting, tech", base: 12500 },
  { id: "mainland", label: "Mainland",  sub: "Local UAE market, government contracts, retail",      base: 14999 },
  { id: "notsure",  label: "Not Sure Yet", sub: "We'll compare both options for you",              base: 12500 },
];

// --- Timelines ---
export const TIMELINES = ["This Month", "Next Month", "3 Months", "6 Months"];



// --- Step Labels ---
export const STEP_LABELS = ["Activity", "Details", "Office", "Location", "Estimate"];
export const TOTAL_STEPS = 5;

// --- Pricing Constants ---
export const VISA_COST        = 3000;
export const SHAREHOLDER_COST = 1000;
